import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import(/* webpackChunkName: "dashboard" */ './views/Layout.vue'),
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    // route level code-splitting
                    // this generates a separate chunk (about.[hash].js) for this route
                    // which is lazy-loaded when the route is visited.
                    component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue'),
                },
                //User module
                {
                    path: '/user/index',
                    name: 'userIndex',
                    component: () => import(/* webpackChunkName: "userIndex" */ './views/user/Index.vue')
                },
                {
                    path: '/user/create',
                    name: 'userCreate',
                    component: () => import(/* webpackChunkName: "userCreate" */ './views/user/Create.vue')
                },
                {
                    path: '/user/update/:id',
                    name: 'userUpdate',
                    component: () => import(/* webpackChunkName: "userUpdate" */ './views/user/Update.vue')
                },
                //Apps module

                {
                    path: '/apps/index',
                    name: 'appIndex',
                    component: () => import(/* webpackChunkName: "appIndex" */ './views/apps/Index.vue')
                },
                {
                    path: '/apps/create',
                    name: 'appCreate',
                    component: () => import(/* webpackChunkName: "appCreate" */ './views/apps/Create.vue')
                },
                {
                    path: '/apps/update/:id',
                    name: 'appUpdate',
                    component: () => import(/* webpackChunkName: "appUpdate" */ './views/apps/Update.vue')
                }
            ]

        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "layoutLogin" */ './views/LayoutLogin.vue'),
            children: [
                {
                    path: '/login',
                    name: 'login',
                    // route level code-splitting
                    // this generates a separate chunk (about.[hash].js) for this route
                    // which is lazy-loaded when the route is visited.
                    component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
                },
                {
                    path: '/forgot',
                    name: 'forgot',
                    component: () => import(/* webpackChunkName: "forgot" */ './views/password/Forgot.vue')
                },
                {
                    path: '/reset',
                    name: 'reset',
                    component: () => import(/* webpackChunkName: "reset" */ './views/password/Reset.vue')
                }
            ]

        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})

// redirect to login page if not logged in and trying to access a restricted page
router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/forgot', '/reset'];
    const authRequired = !publicPages.includes(to.path);
    let loggedIn = store.getters.isAuthenticated;

    //Niet toegelaten -> redirect naar login
    if (authRequired && !loggedIn) {
        next({
            name: 'login'
        })
        //Toegelaten en op login pagina -> redirect naar dashboard
    } else if ('/login' === to.path && loggedIn) {
        next({
            name: 'dashboard'
        })
        //Toegelaten
    } else if (loggedIn) {
        next()
    } else {
        next()
    }
})

export default router
